import { genericApiCall, getApiCall } from "../utils/servicesBaseUtil";
import { catchErrors } from "../utils/catchErrors";
import {
  PAYMENT_INTENT,
  PAYMENT_PROCESS,
  SUBSCRIPTION_PLANS,
  CANCEL_SUBSCRIPTION,
  BILLING_HISTORY,
  TOGGLE_SUBSCRIPTION,
} from "../constants/url";
import { getEncodedParams } from "../utils/generateFormData";
import { message } from "antd";

export const createPaymentIntentApi = ({
  finalCallback,
  successCallback,
  data,
}) => {
  return (dispatch) => {
    let url = PAYMENT_INTENT;
    let formData = getEncodedParams(data);

    genericApiCall({
      url: url,
      method: "POST",
      data: formData,
    })
      .then((responseJson) => {
        if (responseJson?.success) {
          successCallback(responseJson?.data);
        } else {
          message.error(responseJson?.message);
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        finalCallback();
      });
  };
};

export const processPaymentApi = ({ data, successCallback, finalCallback }) => {
  return (dispatch) => {
    let url = PAYMENT_PROCESS;
    let formData = getEncodedParams(data);
    genericApiCall({
      url: url,
      method: "POST",
      data: formData,
    })
      .then((responseJson) => {
        if (responseJson?.success) {
          localStorage.setItem("alrounderToken", responseJson?.data?.token);
          successCallback(responseJson);
        } else {
          message.error(responseJson?.message);
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        finalCallback();
      });
  };
};

export const getSubscriptionPlansApi = ({
  finalCallback,
  successCallback,
  unAunthenticatedCallback,
}) => {
  return () => {
    let url = SUBSCRIPTION_PLANS;

    getApiCall({ url })
      .then((responseJson) => {
        if (responseJson?.success) {
          successCallback(responseJson?.data);
        } else {
          if (unAunthenticatedCallback) {
            unAunthenticatedCallback();
          }
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        if (finalCallback) {
          finalCallback();
        }
      });
  };
};

export const cancelSubscriptionApi = ({ finalCallback, successCallback }) => {
  return (dispatch) => {
    let url = `${CANCEL_SUBSCRIPTION}`;

    genericApiCall({
      url: url,
      method: "POST",
    })
      .then((responseJson) => {
        if (responseJson?.success) {
          successCallback(responseJson?.data);
          message.success(responseJson?.message);
        } else {
          message.error(responseJson?.message);
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        finalCallback();
      });
  };
};

export const toggleSubscriptionApi = ({ finalCallback, successCallback }) => {
  return (dispatch) => {
    let url = `${TOGGLE_SUBSCRIPTION}`;
    
    genericApiCall({
      url: url,
      method: "POST",
    })
      .then((responseJson) => {
        if (responseJson?.success) {
          successCallback(responseJson?.data);
          message.success(responseJson?.message);
        } else {
          message.error(responseJson?.message);
        }
      })         
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        finalCallback();
      });
  }
};

export const getBillingHistoryApi = ({
  finalCallback,
  successCallback,
  unAunthenticatedCallback,
}) => {
  return () => {
    let url = BILLING_HISTORY;

    getApiCall({ url })
      .then((responseJson) => {
        if (responseJson?.success) {
          successCallback(responseJson?.data);
        } else {
          if (unAunthenticatedCallback) {
            unAunthenticatedCallback();
          }
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        if (finalCallback) {
          finalCallback();
        }
      });
  };
};
